import React, { useEffect, useState } from 'react';
import Preloader from './components/Preloader';
import Your from "./components/Your"
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import CTA from './components/CTA';
import Card from './components/Card';
import Banner from './components/Banner';
import Parralox from './components/Parralox';
import Footer from './components/Footer';
import Aboutus from './components/Aboutus';
import Message from './components/Message';
import Commitees from './components/Committe';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Switch } from 'react-router-dom/cjs/react-router-dom.min';


const App = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simulating a delay to show the preloader
    setTimeout(() => {
      setIsLoading(false);
    }, 600);
  }, []);

  return (
   <div> {isLoading ? 
    <Preloader /> : <><Banner/><Footer/> </>} </div>

  );
};

export default App;
